import BaseCollection from "lib/collection";
import Warehouse from "models/warehouse";

export default BaseCollection.extend({
    mainIndex: "id",
    url() {
        if (this.parent._id) {
            return `/api/v3.0/item/${this.parent._id}/warehouses`;
        }
        return "/api/v3.0/warehouses";
    },

    model: Warehouse,
});
